import { render, staticRenderFns } from "./LoadOrderShow.vue?vue&type=template&id=603119ff&scoped=true&"
import script from "./LoadOrderShow.vue?vue&type=script&lang=js&"
export * from "./LoadOrderShow.vue?vue&type=script&lang=js&"
import style0 from "./LoadOrderShow.vue?vue&type=style&index=0&id=603119ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603119ff",
  null
  
)

export default component.exports